<template>
    <div class="acountStatus">  
        <div class="mainTitle text-center my-3">
            <h3 class="mb-4"> {{$t('withdrawalList')}}</h3>
            <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        </div> 
        <div class="whiteBG radius pt-3"> 
            <div class="d-flex flex-wrap tabcenter justify-content-between border-bottom pb-3 px-3 mb-2">
                <div class="accountType  d-flex justify-content-start align-items-center">
                     <a :class="(listStatus == '')?'active' : ''" href="#" @click="filter('')">  {{$t('all')}}</a> 
                     <a :class="(listStatus == '0')?'active' : ''" href="#" @click="filter('0')"> {{$t('pending')}}</a> 
                     <a :class="(listStatus == '1')?'active' : ''" href="#" @click="filter('1')"> {{$t('processed')}}</a> 
                     <a :class="(listStatus == '3')?'active' : ''" href="#" @click="filter('3')"> {{$t('rejected')}}</a> 
                </div>
                <div class="requestbtn d-flex align-items-center">
                    <filter-component ref="form"></filter-component>
                </div>
            </div>
            <div class="inMiddle-area table-responsive"> 
                <table class="table pmmTable">
                    <thead>
                        <tr>
							<th> {{$t('created')}}</th>
                            <th> {{$t('accountId')}}</th>
                            <th> {{$t('amount')}}</th>
                            <th> {{$t('currency')}}</th>
                            <th> {{$t('withdrawalType')}}</th>
							<th> Method </th>
							<th> {{$t('withdrawalStatus')}}</th>
                            <th> {{$t('detail')}}</th>
                        </tr>
                    </thead>
                    <tbody v-if="(!pageLoader && withdrawalList != '' && withdrawalList.totalRecords > 0)">
                        <tr v-for="list in withdrawalList.records" >
                            <td>{{list.created | moment("DD MMMM YYYY")}}</td>
							<td>{{list.account_id}} </td>
                            <td>{{list.amount}}</td>
                            <td><img :src="'../../../../static/fxView/images/'+currency[list.currency.toUpperCase()]" class="data_currency"></td>
                            <td>{{withdrawalType[list.withdrawal_type]}}</td>
							<td>{{depositMethod[list.withdrawal_method]}}</td>
							<td><span class="badge badge-pill" :class="(parseInt(list.withdrawal_status) == 2)? 'badge-danger'  : 'badge-warning'">{{withdrawalStatus[list.withdrawal_status]}}</span></td>
                            <td> 
                                <router-link :to="{name: 'fxView.view' , query: { 'id':list.ticket_id}}" class="prism_btn width_xs btn_xs green_btn" title="View" data-placement="top"  data-toggle="tooltip" @click.native="viewTicketEvent">
                                    {{$t('viewTicket')}}
                                </router-link>
                                <a title="Cancel Withdrawal Request" v-if="(list.withdrawal_status == '0') && (list.IS_LOCKED == '0')" href="javascript:void(0)" class="red" @click="cancelwithData = list">
                                    <feather type="x-circle"></feather>
                                </a>                                
                            </td>
                        </tr>
                    </tbody>
                    <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="withdrawalList" v-else></loader-component>
                </table>
            </div>
        </div>
        <pagination :getList="withdrawalList" :limit="pageLimit" v-if="withdrawalList.totalRecords > 0"></pagination>
        <div class="modal fade show" style="display: block;" v-if="Object.keys(cancelwithData).length > 0">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Cancel Withdrawal Request</h5>
                        <button type="button" class="close" @click="cancelwithData = {}">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body my-3">
                        <h4>Are you sure you want to cancel the withdrawal request?</h4>
                    </div>
                    <div class="modal-footer">
                        <a href="javascript:void(0)" class="common_btn redBG" @click="cancelwithData = {}">Cancel</a>
                        <a href="javascript:void(0)" class="common_btn " @click="cancelwithdrawalreq(cancelwithData.ticket, cancelwithData.ticket_id)">Proceed</a>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
        data() {
            return {
                //===========prop in loader component=======
                col_span : 7,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                listStatus : '',
                //==========================================
                pageLimit : '15',
                search : '',
                page : '1',
                cancelwithData:{}
            }
        },
        methods:{
            cancelwithdrawalreq(ticket, ticket_id){
                if(this.pageLoader) {
                    return
                }
                let input_json = {
                'globalParams': {
                    'ticket': ticket,
                    'ticket_id': ticket_id
                },
                'localParams': { "parameter": this }
                }
                this._runCancelWithdrawalRequest(input_json)
            },
            filter(getData){
                this.listStatus = getData
                this.$refs.form.resetdata()
            },
            listing(){
                let inputJson = {
                    'globalParams' : {
                        filter: {'withdrawal.withdrawal_status' : this.listStatus},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,
                    'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetWithdrawalList(inputJson)
            },
            viewTicketEvent(){
                this.$trackEvent('CP+Account+Funding+View+Ticket');
            }
        },
        created(){
            if(this.$store.getters[Const.GET_WITHDRAWAL_LIST] != ''){
                this.loaderFuncRun = '0'
            }
            this.listing()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/withdrawal/withdrawal_listing.vue